import { render, staticRenderFns } from "./EmailAlternate.vue?vue&type=template&id=fca00190&"
import script from "./EmailAlternate.vue?vue&type=script&lang=js&"
export * from "./EmailAlternate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports